(ns hai.ui.toast
  (:require
   [garden.stylesheet]
   [hai.ui.rf-sugar :refer [defevent-fx defeffect]]
   [lambdaisland.ornament :as o]
   [reagent.core :as reagent]))

(def !state (reagent/atom []))

#_{:clj-kondo/ignore [:clojure-lsp/unused-public-var]}
(o/defrules toast-keyframes
  (garden.stylesheet/at-keyframes
   :toast-slide-up
   [:from {:transform "translateY(12px)" :opacity "0"}]
   [:to   {:transform "translateY(0)"    :opacity "1"}]))

(o/defstyled Toast :div
  {:display        "flex"
   :flex-direction "row"
   :align-items    "flex-start"
   :gap            "12px"
   :max-width      "340px"
   :padding        "15px 18px 16px"
   :border-radius  "3px"
   :background     "#3d5560"
   :color          "#f6efdd"
   :font-family    "'Geist', system-ui, -apple-system, BlinkMacSystemFont, sans-serif"
   :font-size      "14px"
   :font-weight    "500"
   :line-height    "1.5"
   :box-shadow     "0 1px 1px rgba(60,40,20,0.06), 0 12px 26px rgba(60,40,20,0.18)"
   :animation      "toast-slide-up 220ms cubic-bezier(.2,.7,.3,1) both"
   :pointer-events "auto"}
  [:&.success {:background "#4f6d35"}]
  [:&.error   {:background "#9a4128"}]
  [:.icon
   {:flex            "0 0 auto"
    :margin-top      "2px"
    :color           "#f6efdd"
    :display         "inline-flex"
    :align-items     "center"
    :justify-content "center"}
   [:svg
    {:width           "15px"
     :height          "15px"
     :stroke          "currentColor"
     :stroke-width    "2"
     :stroke-linecap  "round"
     :stroke-linejoin "round"
     :fill            "none"}]]
  [:.text
   {:flex       "1"
    :min-width  "0"
    :word-break "break-word"}]
  ([{:keys [text level]}]
   (let [klass (case level
                 :success "success"
                 :error   "error"
                 "info")
         icon  (case level
                 :success
                 [:svg {:viewBox "0 0 24 24"}
                  [:polyline {:points "20 6 9 17 4 12"}]]
                 :error
                 [:svg {:viewBox "0 0 24 24"}
                  [:line {:x1 "6"  :y1 "6" :x2 "18" :y2 "18"}]
                  [:line {:x1 "18" :y1 "6" :x2 "6"  :y2 "18"}]]
                 ;; info — default for any non-success/error level
                 [:svg {:viewBox "0 0 24 24"}
                  [:circle {:cx "12" :cy "12" :r "9"}]
                  [:circle {:cx "12" :cy "7.5" :r "1.2"
                            :fill "currentColor" :stroke "none"}]
                  [:line {:x1 "12" :y1 "11" :x2 "12" :y2 "16"}]])]
     [:<> {:class klass}
      [:span.icon icon]
      [:div.text text]])))

(o/defstyled ToastWrapper :div
  {:position       "fixed"
   :bottom         "16px"
   :right          "16px"
   :z-index        "9999"
   :display        "flex"
   :flex-direction "column"
   :gap            "10px"
   :pointer-events "none"}
  ([]
   ;; A live region, so toasts are announced rather than only seen. Polite (not
   ;; assertive) because toasts confirm rather than interrupt, and without
   ;; aria-atomic so adding one announces just that toast, not every toast
   ;; currently on screen.
   [:<>
    {:role "status" :aria-live "polite"}
    (doall
     (for [{:keys [id] :as toast} @!state]
       ^{:key id}
       [Toast toast]))]))

(defn create [{:keys [text level timeout]
               :or {level :info
                    timeout 5000}}]
  {:id (random-uuid)
   :text text
   :timeout timeout
   :level level})

(defn remove! [{:keys [id]}]
  (swap! !state #(remove (fn [t] (= (:id t) id)) %)))

(defn add! [opts]
  (let [toast (create opts)]
    (swap! !state conj toast)
    (js/setTimeout #(remove! toast) (:timeout toast))))

(defn success! [opts] (add! (assoc opts :level :success)))
(defn info!    [opts] (add! (assoc opts :level :info)))
(defn error!   [opts] (add! (assoc opts :level :error)))

(defeffect :toast/add [opts]
  (add! opts))

(defevent-fx :toast/add [{:keys [db]} opts]
  {:toast/add (assoc opts :level :info)})

(defevent-fx :toast/success [{:keys [db]} opts]
  {:toast/add (assoc opts :level :success)})

(defevent-fx :toast/info [{:keys [db]} opts]
  {:toast/add (assoc opts :level :info)})

(defevent-fx :toast/error [{:keys [db]} opts]
  {:toast/add (assoc opts :level :error)})
